import { EnrichmentLogo } from '@src/components/shared/Logo';
import { resources } from '@src/resources';
import { Loader2,LogIn } from 'lucide-react';
import { useAuth } from 'react-oidc-context';

export function Login() {
  const auth = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-8 rounded-3xl border border-border bg-card p-10 shadow-xl">
        <div className="text-center">
          <div className="mb-6 flex justify-center">
            <EnrichmentLogo size={48} />
          </div>
          <h1 className="text-3xl font-extrabold tracking-tight text-foreground">{resources.login.title}</h1>
          <p className="mt-2 text-sm text-muted-foreground">{resources.login.tagline}</p>
        </div>

        <div className="mt-10 space-y-4">
          <button
            onClick={() => auth.signinRedirect()}
            disabled={auth.isLoading}
            className="flex w-full items-center justify-center gap-3 rounded-2xl border border-input bg-card px-4 py-4 text-sm font-bold text-foreground shadow-sm transition-all hover:bg-accent focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {auth.isLoading ? (
              <Loader2 className="h-5 w-5 animate-spin text-primary" />
            ) : (
              <LogIn className="h-5 w-5 text-primary" />
            )}
            {auth.isLoading ? resources.login.signInLoading : resources.login.signIn}
          </button>
        </div>

        <div className="mt-8 border-t border-border pt-8 text-center">
          <p className="text-xs text-muted-foreground">{resources.login.legalNote}</p>
        </div>
      </div>
    </div>
  );
}
